import moment from 'moment'
import { languages } from '@/types/languages'

export function getLanguageName(str: string) {
    return languages.filter((item) => item['639-2'] == str)[0]['language-name']
}

export function getAbrv(str: string) {
    let abrv = ''
    str.split(' ').map((item: string) => {
        abrv = abrv + item.charAt(0).toUpperCase()
    })
    return abrv
}

export function capitalizeFLetter(str: string) {
    return str[0].toUpperCase() + str.slice(1)
}

export function truncateString(str: string, num: number) {
    if (str.length <= num) {
        return str
    }
    let arr = str.slice(0, num).split(' ')
    return arr.slice(0, arr.length - 1).join(' ') + '...'
}

export function formatTime(date: any) {
    return date ? moment(date).format('HH:mm') : ''
}

export function formatDate(date: any) {
    return date ? moment(date).format('DD MMM YY') : ''
}

export function unflattenArray(items: Array<any>, id: any): Array<any> {
    return items
        .filter((item) => item.relationships?.parent?.data?.id === id)
        .map((item) => ({ ...item, children: unflattenArray(items, item.id) }))
}

export function activeTree(items: Array<any>, child: any): any {
    let res = child
    let stat = true

    function inner(params: any) {
        if (params.relationships.parent.data) {
            res = items.filter((item: any) => item.id === params.relationships.parent.data.id)[0]
            Object.assign(res, { child: params })
            stat = true
        } else {
            stat = false
            res = params
        }
    }

    do {
        inner(res)
    } while (stat)
    return res
}

export function checkPermission(permissions: any, str: string) {
    let res = false
    Object.keys(permissions).map((item) => {
        if (item.includes(str)) {
            res = true
        }
    })

    if (Object.keys(permissions).length == 0 && !str) {
        res = true
    }

    return res
}

export function IsJsonString(str: string) {
    if (str)
        try {
            JSON.parse(str)
        } catch (e) {
            return false
        }
    return true
}

export function editorToString(editor: any) {
    let res = editor

    if (IsJsonString(editor)) {
        let parsedText = JSON.parse(editor)

        if (parsedText.type) {
            if (parsedText.type == 'text') {
                res = parsedText.data
            } else if (parsedText.type == 'editorjs') {
                res = ''
                parsedText.data.blocks.map((item: any) => {
                    if (item.type == 'paragraph') {
                        res += ' ' + item.data.text
                    }
                })
            }
        } else {
            res = ''
            parsedText.blocks.map((item: any) => {
                if (item.type == 'paragraph') {
                    res += ' ' + item.data.text
                }
            })
        }
    }

    return res
}
